import { loadable } from 'utils';

export const Regular = loadable(() => import('./Regular'), {});
